export default {
  data() {
    return {
      windowInnerWidth: window.innerWidth,
    }
  },

  computed: {
    isPhoneLayout() {
      return this.windowInnerWidth < 800;
    }
  },

  mounted() {
    // https://stackoverflow.com/a/47219938
    this.$nextTick(() => {
      this.onResizeFunction = () => {
        this.windowInnerWidth = window.innerWidth;
      };
      window.addEventListener('resize', this.onResizeFunction);
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResizeFunction);
  }
}
